import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import {SVGIcon} from '@homeaway/react-svg';
import {ALERT_WARNING__32} from '@homeaway/svg-defs/lib/defs/ALERT_WARNING__32';
import {MAIL__24} from '@homeaway/svg-defs/lib/defs/MAIL__24';
import {MONEY__24} from '@homeaway/svg-defs/lib/defs/MONEY__24';
import {RecommendationCarousel} from '../../../../RecommendationCarousel/RecommendationCarousel';

import './CancelTripModalRefundConfirmation.less';

export default class CancelTripModalRefundConfirmation extends Component {
    static propTypes = {
        errorMessage: PropTypes.string,
        errorTitle: PropTypes.string,
        hasError: PropTypes.bool,
        location: PropTypes.string,
        recommendedListings: PropTypes.arrayOf(PropTypes.object),
        refundEmailMessage: PropTypes.string,
        refundMessage: PropTypes.string,
        refundTitle: PropTypes.string,
        requestMarker: PropTypes.string,
    };

    static defaultProps = {
        errorMessage: '',
        errorTitle: '',
        hasError: false,
        location: '',
        recommendedListings: [],
        refundEmailMessage: '',
        refundMessage: '',
        refundTitle: '',
        requestMarker: '',
    };

    render() {
        const {
            errorMessage,
            errorTitle,
            hasError,
            location,
            recommendedListings,
            refundEmailMessage,
            refundMessage,
            refundTitle,
            requestMarker,
            translations,
        } = this.props;

        if (hasError) {
            return (
                <div className="CancelTrip__step text-center">
                    <SVGIcon
                        className="CancelTrip__error-icon text-danger"
                        markup={ALERT_WARNING__32}
                    />
                    <h3 className="CancelTrip__title">{errorTitle}</h3>
                    <p className="CancelTrip__text">{errorMessage}</p>
                </div>
            );
        }

        const hasRecommendedData = !!recommendedListings?.length;

        return (
            <div className="CancelTrip__step">
                <h3 className="CancelTrip__title">{refundTitle}</h3>
                <div className="CancelTrip__text">
                    <div className="CancelTripModalRefundConfirmation__info">
                        {refundMessage && (
                            <Fragment>
                                <div className="CancelTripModalRefundConfirmation__icon circle-bullet">
                                    <SVGIcon markup={MONEY__24} />
                                </div>
                                <div className="CancelTripModalRefundConfirmation__text">
                                    {refundMessage}
                                </div>
                            </Fragment>
                        )}
                    </div>
                    <div className="CancelTripModalRefundConfirmation__info">
                        <div className="CancelTripModalRefundConfirmation__icon circle-bullet">
                            <SVGIcon markup={MAIL__24} />
                        </div>
                        <div className="CancelTripModalRefundConfirmation__text">
                            {refundEmailMessage}
                        </div>
                    </div>
                </div>
                {hasRecommendedData && (
                    <RecommendationCarousel
                        data={{
                            clientRequestId: requestMarker,
                            recommendedListings,
                        }}
                        location={location}
                        translations={translations}
                    />
                )}
            </div>
        );
    }
}
